import React from "react"
import { withTranslation } from "react-i18next";
import { GuestRepseDocumentsView } from "../../views"
import { LocalStorageService, RepseService, ContractorService, WorkflowService } from "../../../services";

class GuestRepseDocumentsAction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            showButton: false,
            messageButton: 'Aceptar',
            messageError: '',
            contractors: [],
            selectedContractor: null,
            contracts: [],
            selectedContract: null,
            documentsRepse: [],
            yearFilterOptions: [],
            selectedYear: 0,
            itemGrid: {},
            monthSelected: 0,
            showModalPdf: false,
            isLoadingModalPdf: false,
            selectedFile: null,
            errorFile: false,
            selectedFileBase64: "",
            colorBorderContainer: "gray",
            showAWS: true,
            urlPdf: '',
        }
    }


    token = {};
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    repseService = new RepseService(this.url)
    contractorService = new ContractorService(this.url)
    workflowService = new WorkflowService(this.url);

    userId = 0

    async componentDidMount() {
        this.toggleLoadingScreen(true);
        const user = this.localStorageService.getLocalStorageItem("user");
        this.userId = user.userMetaData.userMifirma.id;
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;

        let years = [];
        let currentYear = new Date().getFullYear();
        for (let i = 2022; i <= currentYear; i++) {
            let yearStr = i.toString();
            years.push({
                year: yearStr,
                yearValue: yearStr,
            })
        }

        const searchParams = new URLSearchParams(this.props.location.search);
        const urlYear = searchParams.get("year");
        currentYear = urlYear ? urlYear : currentYear;

        this.getContractorsByUserId(currentYear)
        this.setState({
            user: user,
            token: this.token,
            yearFilterOptions: years
        })
    }

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value, message, button) => {
        this.setState({
            showCompletedRequesting: value,
            messageComplete: message,
            showButton: button
        });
    }

    //get info contractor bys userId
    getContractorsByUserId = async (year) => {
        const searchParams = new URLSearchParams(this.props.location.search);
        const urlContractorId = searchParams.get("contractor");

        let errorContractor = 'Ocurrió un error al consultar la información del provedor'
        try {
            let response = await this.contractorService.getContractorsByUserId(this.userId, this.token)
            if (response && response.data && Number(response.statusCode) === 200) {
                let contractors = response.data;
                contractors.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

                let selectedContractor = null;
                if (Object.keys(contractors).length > 0) {
                    if (urlContractorId) {
                        selectedContractor = contractors.find(c => c.id == urlContractorId)
                    }
                    if (!selectedContractor) {
                        selectedContractor = contractors[0]
                    }
                }

                this.setState({
                    contractors: contractors,
                    selectedContractor: selectedContractor,
                });

                if (selectedContractor) this.getContractsRepse(selectedContractor.id, year)

                this.toggleLoadingScreen(false)
            } else {
                this.toggleLoadingScreen(false)
                this.toggleErrorRequesting(true, errorContractor, 4000, true)

            }
        } catch (error) {
            this.toggleLoadingScreen(false)
            this.toggleErrorRequesting(true, errorContractor, 4000, true)
        }
    }

    //handle filter year
    onYearFilterChange = (year) => {
        this.getContractsRepse(this.state.selectedContractor.id, year)
    }

    onContractorFilterChange = (contractorId) => {
        this.getContractsRepse(contractorId, this.state.selectedYear)
    }

    // CONTRACTS    
    getContractsRepse = async (contractorId, year) => {
        const searchParams = new URLSearchParams(this.props.location.search);
        const urlContractId = searchParams.get("contract");

        this.toggleLoadingRequesting(true);
        try {
            let response = await this.repseService.getRepseContractsByContractor(this.token, contractorId, year);

            if (response.statusCode == 200) {
                let contracts = response.data;
                contracts.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

                let selectedContract = null;
                if (Object.keys(contracts).length > 0) {
                    if (urlContractId) {
                        selectedContract = contracts.find(c => c.id == urlContractId)
                    }
                    if (!selectedContract) {
                        selectedContract = contracts[0]
                    }
                }

                let documents = selectedContract?.documents || [];
                documents.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

                let newParams = new URLSearchParams()
                newParams.append("contractor", contractorId)
                if (selectedContract) newParams.append("contract", selectedContract.id)
                newParams.append("year", year)

                this.props.history.replace({ pathname: `/guest-repse-documents`, search: newParams.toString() })

                let documentsRepse = []
                if (selectedContract && selectedContract.documents) {
                    documentsRepse = selectedContract.documents.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                }

                this.setState({
                    contracts: response.data,
                    selectedContract: selectedContract,
                    documentsRepse,
                    selectedYear: year
                })
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo los contratos del proveedor.")
            }
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000);
        } finally {
            this.toggleLoadingRequesting(false);
        }
    }

    getColorByContractStatus = (status) => {
        switch (status.toLowerCase()) {
            case "validado":
                return "green";
            case "pendiente":
                return "yellow";
            case "vencido":
                return "red";
            case "sin validar":
                return "gray";
            default:
                return "";
        }
    }

    onContractSelected = (contract) => {
        if (!contract.id) return;

        let newParams = new URLSearchParams()
        newParams.append("contractor", this.state.selectedContractor.id)
        newParams.append("contract", contract.id)
        newParams.append("year", this.state.selectedYear)

        this.props.history.replace({ pathname: `/guest-repse-documents`, search: newParams.toString() })

        let documentsRepse = []
        if (contract.documents) {
            documentsRepse = contract.documents.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        }

        this.setState({
            selectedContract: contract,
            documentsRepse,
        })
    }

    // DOCUMENTS
    getColorByDocumentStatus = (status) => {
        switch (parseInt(status.statusDocumentId)) {
            case +process.env.REACT_APP_STATUS_DOCUMENT_VALIDATED_ID:
                return "green";
            case +process.env.REACT_APP_STATUS_DOCUMENT_PENDING_ID:
            case +process.env.REACT_APP_STATUS_DOCUMENT_REJECTED:
                return "yellow";
            case +process.env.REACT_APP_STATUS_DOCUMENT_NO_VALIDATED_ID:
                return "red";
            case +process.env.REACT_APP_STATUS_DOCUMENT_NOT_NEEDED_ID:
                return "gray";
            default:
                return "";
        }
    }

    pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        }
        );

    //handle set file in modal
    handleFile = async (e) => {
        this.toggleLoadingModalPdf()
        this.setState({
            selectedFile: e.target.files[0],
            selectedFileName: e.target.files[0].name,
            errorFile: false,
            colorBorderContainer: "green",
            showAWS: false
        });

        // Upload the base64 in the state
        let fileBase64 = await this.pdfToBase64(e.target.files[0]);
        let pdfBase64 = fileBase64.split(",")[1];
        this.setState({ selectedFileBase64: pdfBase64 });
        this.toggleLoadingModalPdf()
    };

    //Delete file in modal
    handleDeleteFile = (e) => {
        this.setState({
            urlPdf: '',
            selectedFile: null,
            errorFile: false,
            deletePfd: true,
            selectedFileBase64: "",
            colorBorderContainer: "gray",
            showAWS: false
        });
        return true;
    };

    //handle cirlce buttons for GridSemaforo
    handleClickButtons = async (dataItem, index) => {
        this.toggleLoadingRequesting(true);
        let monthItem = index + 1
        let monthInfo = dataItem.compliance[monthItem]
        let path = ''

        try {
            if (monthInfo && monthInfo.filePath && monthInfo.filePath !== "") {
                let response = await this.repseService.getDocumentUrl(this.token, monthInfo.filePath)
                if (response.statusCode == 200) {
                    path = response.data
                } else {
                    throw new Error(response.data.message || "Ocurrió un error obteniendo el documento.")
                }
            }
            this.setState({
                itemGrid: dataItem,
                monthSelected: monthItem,
                urlPdf: path,
                showAWS: path != ''
            })

            this.toggleLoadingRequesting(false);
            this.toggleShowModalPdf(true)
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    //create worflow document REPSE with status 0
    handleCreateWorkflow = async () => {
        if (!this.state.selectedFile) {
            let errorNoDoc = 'No ha seleccioado ningun documento'
            this.toggleShowModalPdf()
            this.toggleErrorRequesting(true, errorNoDoc, 4000)
            setTimeout(() => {
                this.toggleShowModalPdf()
            }, 4000)
            return
        }

        this.toggleShowModalPdf()
        this.toggleLoadingRequesting(true)
        let erroWorkflow = 'No se pudo crear el workflow del documento'

        try {
            let file = this.state.selectedFile
            let repseDocument = new FormData();
            repseDocument.append("contractorId", this.state.selectedContractor.id);
            repseDocument.append("documentId", this.state.itemGrid.id);
            repseDocument.append("year", this.state.selectedYear);
            repseDocument.append("month", this.state.monthSelected);
            repseDocument.append("statusDocumentId", +process.env.REACT_APP_STATUS_DOCUMENT_PENDING_ID);
            repseDocument.append("repseContractId", this.state.selectedContract.id);
            repseDocument.append("repseDocument", file);

            let workflow = await this.workflowService.createRepseDocWorflow(repseDocument, this.token)
            this.toggleLoadingRequesting(false)
            if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
                if(workflow.data.isLastDocument === true){
                    this.toggleCompletedRequesting(true, 'Con la carga de este documento enviaremos a validar tu información. Gracias.', true)
                    this.getContractsRepse(this.state.selectedContractor.id, this.state.selectedYear)
                }else{
                    this.toggleCompletedRequesting(true, null, false)
                    setTimeout(() => {
                        this.toggleCompletedRequesting(false, null, false)
                        this.getContractsRepse(this.state.selectedContractor.id, this.state.selectedYear)
                    }, 4000)
                }
            } else {
                this.toggleErrorRequesting(true, erroWorkflow, 4000)
                setTimeout(() => {
                    this.toggleShowModalPdf()
                }, 4000)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true, erroWorkflow, 4000)
            setTimeout(() => {
                this.toggleShowModalPdf()
            }, 4000)
        }
    }

    setUrlPdf = (url) => {
        this.setState({
            urlPdf: url
        })
    }

    toggleShowModalPdf = () => {
        this.setState({
            showModalPdf: !this.state.showModalPdf,
            selectedFile: null,
        })
    }

    toggleCloseShowModal = () => {
        this.handleDeleteFile()
        this.toggleShowModalPdf()
    }

    toggleLoadingModalPdf = () => {
        this.setState({
            isLoadingModalPdf: !this.state.isLoadingModalPdf
        })
    }

    toggleShowAwsPdf = () => {
        this.setState({
            showAWS: !this.state.showAWS
        })
    }


    render() {
        return (
            <GuestRepseDocumentsView
                {...this.state}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                onContractorFilterChange={this.onContractorFilterChange}
                onYearFilterChange={this.onYearFilterChange}
                getColorByContractStatus={this.getColorByContractStatus}
                onContractSelected={this.onContractSelected}
                getColorByDocumentStatus={this.getColorByDocumentStatus}
                handleClickButtons={this.handleClickButtons}
                handleFile={this.handleFile}
                handleDeleteFile={this.handleDeleteFile}
                toggleShowModalPdf={this.toggleShowModalPdf}
                handleCreateWorkflow={this.handleCreateWorkflow}
                toggleCloseShowModal={this.toggleCloseShowModal}
            />
        )
    }
}

export default withTranslation()(GuestRepseDocumentsAction);
